import { cloneDeep, pick } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { getMaterialAssets } from '@/i18n/assets';
import { Cell, LayerType, TextAlignType } from '@/version-types';
import { TablePreset } from '.';
import presetImage from './assets/preset3.png';

const PRESET_ID = '081b3408';

const getTableByPreset: TablePreset['create'] = () => {
    return {
        id: uuidv4(),
        layerType: LayerType.TABLE,
        width: 869,
        height: 522,
        rotate: 0,
        opacity: 1,
        title: '',
        fitWidth: 0,
        fitHeight: 0,
        materialIds: {},
        extraInfo: {
            lockRatio: false,
        },
        data: {
            presetId: PRESET_ID,
            screenshotUrl: getMaterialAssets().tableLayer.screenshotUrl.table3,
            cells: [
                [
                    {
                        hIndex: 0,
                        vIndex: 0,
                        colSpan: 1,
                        rowSpan: 1,
                        content: '',
                        styleIds: [],
                    },
                    {
                        hIndex: 1,
                        vIndex: 0,
                        colSpan: 1,
                        rowSpan: 1,
                        content: '',
                        styleIds: [],
                    },
                    {
                        hIndex: 2,
                        vIndex: 0,
                        colSpan: 1,
                        rowSpan: 1,
                        content: '',
                        styleIds: [],
                    },
                    {
                        hIndex: 3,
                        vIndex: 0,
                        colSpan: 1,
                        rowSpan: 1,
                        content: '',
                        styleIds: [],
                    },
                ],
                [
                    {
                        hIndex: 0,
                        vIndex: 1,
                        colSpan: 1,
                        rowSpan: 1,
                        content: '',
                        styleIds: [],
                    },
                    {
                        hIndex: 1,
                        vIndex: 1,
                        colSpan: 1,
                        rowSpan: 1,
                        content: '',
                        styleIds: [],
                    },
                    {
                        hIndex: 2,
                        vIndex: 1,
                        colSpan: 1,
                        rowSpan: 1,
                        content: '',
                        styleIds: [],
                    },
                    {
                        hIndex: 3,
                        vIndex: 1,
                        colSpan: 1,
                        rowSpan: 1,
                        content: '',
                        styleIds: [],
                    },
                ],
                [
                    {
                        hIndex: 0,
                        vIndex: 2,
                        colSpan: 1,
                        rowSpan: 1,
                        content: '',
                        styleIds: [],
                    },
                    {
                        hIndex: 1,
                        vIndex: 2,
                        colSpan: 1,
                        rowSpan: 1,
                        content: '',
                        styleIds: [],
                    },
                    {
                        hIndex: 2,
                        vIndex: 2,
                        colSpan: 1,
                        rowSpan: 1,
                        content: '',
                        styleIds: [],
                    },
                    {
                        hIndex: 3,
                        vIndex: 2,
                        colSpan: 1,
                        rowSpan: 1,
                        content: '',
                        styleIds: [],
                    },
                ],
                [
                    {
                        hIndex: 0,
                        vIndex: 3,
                        colSpan: 1,
                        rowSpan: 1,
                        content: '',
                        styleIds: [],
                    },
                    {
                        hIndex: 1,
                        vIndex: 3,
                        colSpan: 1,
                        rowSpan: 1,
                        content: '',
                        styleIds: [],
                    },
                    {
                        hIndex: 2,
                        vIndex: 3,
                        colSpan: 1,
                        rowSpan: 1,
                        content: '',
                        styleIds: [],
                    },
                    {
                        hIndex: 3,
                        vIndex: 3,
                        colSpan: 1,
                        rowSpan: 1,
                        content: '',
                        styleIds: [],
                    },
                ],
            ],
            baseCells: {
                horizontal: [217.25, 217.25, 217.25, 217.25],
                vertical: [129.5, 129.5, 129.5, 129.5],
            },
            allStyleId: '1',
            styles: {
                '1': {
                    fontSize: 30,
                    backgroundColor: '#ffffffff',
                    bold: true,
                    color: '#000000ff',
                    textAlign: TextAlignType.CENTER,
                    border: {
                        top: {
                            color: '#4a4b57ff',
                            style: 'line-0',
                            width: 2,
                        },
                        right: {
                            color: '#00000000',
                            style: 'line-0',
                            width: 0,
                        },
                        bottom: {
                            color: '#4a4b57ff',
                            style: 'line-0',
                            width: 2,
                        },
                        left: {
                            color: '#00000000',
                            style: 'line-0',
                            width: 0,
                        },
                    },
                },
            },
        },
        lock: false,
        children: [],
        shine: true,
        hidden: false,
    };
};

const tablePreset: TablePreset = {
    id: PRESET_ID,
    preview: presetImage,
    create: getTableByPreset,
    overwriteStyle: (oldTableLayer) => {
        const newTableLayer = cloneDeep(oldTableLayer);

        const newStyleId = `${Math.max(0, ...Object.keys(newTableLayer.data.styles).map(Number)) + 1}`;
        const cells = newTableLayer.data.cells.flat().filter(Boolean) as Cell[];
        cells.forEach((c) => {
            c.styleIds.push(newStyleId);
        });
        const presetDemo = getTableByPreset();
        newTableLayer.data.styles[newStyleId] = pick(presetDemo.data.styles['1'], ['border', 'backgroundColor']);

        return newTableLayer;
    },
};

export default tablePreset;
